import React, { ReactNode, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {
	componentPagesMenu,
    dashboardMenuUtama,
    dashboardDonatur,
    dashboardKlasifikasiDonatur,
	dashboardPagesMenu,
	master,
	demoPagesMenu,
	penerimaan,
    donatur,
    barang,
	target,
	targetDonatur,
	gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
	anakAsuh,
	mutasiPenerimaan,
    dashboardLag,
    dashboardBarang,
    dashboardAsrama,
    dashboardMaps,
    crmDonatur,
    koya,
} from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Hand from '../../../assets/img/hand.png';
import HandWebp from '../../../assets/img/hand.webp';
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const [doc, setDoc] = useState(
		localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	);
	const [role, setRole] = useState({});
    const [aksesMenu, setAksesMenu] = useState({
        dashboardMenuUtama: false,
        dashboardLag: false,
        dashboardDonatur: false,
        crmDonatur: false,
        dashboardBarang: false,
        dashboardAsrama: false,
        dashboardMaps: false,
        penerimaan: false,
        donatur: false,
        barang: false,
        target: false,
        targetDonatur: false,
        mutasiPenerimaan: false,
        master: false,
    });
	useEffect(() => {
		const storedData = sessionStorage.getItem('data');
        if (storedData) {
            const parsedData = JSON.parse(storedData);
            setAksesMenu(parsedData.aksesMenu || {});
        }
	}, []);
	const { t } = useTranslation(['translation', 'menu']);

	const { darkModeStatus } = useDarkMode();

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{!doc && (
					<>
						{/* <Navigation menu={dashboardMenuUtama} id='aside-dashboard' />
                        <Navigation menu={dashboardLag} id='aside-dashboard-lag' />
						{role === 1 && <Navigation menu={dashboardDonatur} id='aside-dashboard-donatur' />}
						{role === 1 && <Navigation menu={dashboardBarang} id='aside-dashboard-donatur' />}
						<NavigationLine />
						<Navigation menu={penerimaan} id='aside-penerimaan' />
						{role === 1 && <Navigation menu={target} id='aside-target' />}
						{role === 1 && <Navigation menu={mutasiPenerimaan} id='aside-mutasi' />}
						<NavigationLine />
						{role === 1 && <Navigation menu={master} id='aside-master' />} */}

                        {aksesMenu.dashboardMenuUtama && (
                            <Navigation menu={dashboardMenuUtama} id="aside-dashboard" />
                        )}
                        {/* {aksesMenu.dashboardLag && (
                            <Navigation menu={dashboardLag} id="aside-dashboard-lag" />
                        )} */}
                        {aksesMenu.dashboardDonatur && (
                            <Navigation menu={dashboardDonatur} id="aside-dashboard-donatur" />
                        )}
                        {aksesMenu.crmDonatur && (
                            <Navigation menu={crmDonatur} id="aside-dashboard-donatur" />
                        )}
                        {aksesMenu.dashboardBarang && (
                            <Navigation menu={dashboardBarang} id="aside-dashboard-donatur" />
                        )}
                        {aksesMenu.dashboardAsrama && (
                            <Navigation menu={dashboardAsrama} id="aside-dashboard-donatur" />
                        )}
                        {aksesMenu.dashboardMaps && (
                            <Navigation menu={dashboardMaps} id="aside-dashboard-donatur" />
                        )}
                        <NavigationLine />
                        {aksesMenu.penerimaan && (
                            <Navigation menu={penerimaan} id="aside-penerimaan" />
                        )}
                        {aksesMenu.donatur && (
                            <Navigation menu={donatur} id="aside-donatur" />
                        )}
                        {aksesMenu.target && (
                            <Navigation menu={target} id="aside-target" />
                        )}
                        {aksesMenu.targetDonatur && (
                            <Navigation menu={targetDonatur} id="aside-target-donatur" />
                        )}
                        {aksesMenu.mutasiPenerimaan && (
                            <Navigation menu={mutasiPenerimaan} id="aside-mutasi" />
                        )}
                        <NavigationLine />
                        {aksesMenu.master && (
                            <Navigation menu={master} id="aside-master" />
                        )}
                        {aksesMenu.barang && (
                            <Navigation menu={barang} id="aside-barang" />
                        )}
                        <Navigation menu={koya} id="aside-barang" />
					</>
				)}

				{doc && (
					<>
						<Navigation menu={gettingStartedPagesMenu} id='aside-docMenu' />
						<NavigationLine />
						<Navigation menu={componentPagesMenu} id='aside-componentsMenu' />
						<NavigationLine />
					</>
				)}

				{asideStatus && doc && (
					<Card className='m-3 '>
						<CardBody className='pt-0'>
							<img srcSet={HandWebp} src={Hand} alt='Hand' width={130} height={130} />
							<p
								className={classNames('h4', {
									'text-dark': !darkModeStatus,
									'text-light': darkModeStatus,
								})}>
								{t('Everything is ready!') as ReactNode}
							</p>
							<Button
								color='info'
								isLight
								className='w-100'
								onClick={() => {
									localStorage.setItem('facit_asideDocStatus', 'false');
									setDoc(false);
								}}>
								{t('Demo Pages') as ReactNode}
							</Button>
						</CardBody>
					</Card>
				)}
			</AsideBody>
			<AsideFoot>
				{/* <nav aria-label='aside-bottom-menu'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								localStorage.setItem('facit_asideDocStatus', String(!doc));
								setDoc(!doc);
							}}
							data-tour='documentation'>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon
										icon={doc ? 'ToggleOn' : 'ToggleOff'}
										color={doc ? 'success' : undefined}
										className='navigation-icon'
									/>
									<span className='navigation-text'>
										{t('menu:Documentation') as ReactNode}
									</span>
								</span>
								<span className='navigation-link-extra'>
									<Icon
										icon='Circle'
										className={classNames(
											'navigation-notification',
											'text-success',
											'animate__animated animate__heartBeat animate__infinite animate__slower',
										)}
									/>
								</span>
							</span>
						</div>
					</div>
				</nav> */}
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
